import { getPageUrlParams, appendUrlParam } from '../../common/util'
import { generateMofV3RequestUrl } from '../../common/tool'
import { reportNonBizData } from '../../common/m_common/mNonBizReport'
import { reportUrlList } from '../../common/m_common/mBizReport'
import i18nTools from '../../common/locale/format'
import MoreOffer from '../component/visible/MoreOffer'

export default class MoreOfferManager {
  constructor(opts = {}) {
    this._App = opts.APP || {}
    this._campaign = opts.campaign || (this._App.initData && this._App.initData.campaignList[0])
    this._ecUrl = opts.endScreenUrl || (this._App.initData && this._App.initData.end_screen_url)
    this._options = opts
    this._nImp = this.parseEndScreenUrl('n_imp')
    this._lastPosition = 0
    this._widthPerOffer = 24
    this._nImpReportHistory = []
    this._uiLoadSuccess = false
    this.init()
  }

  init() {
    const mofOpts = {
      onLoadSuccess: this._options.onLoadSuccess || [],
      onLoadFailed: this._options.onLoadFailed || [() => {
        console.log('Load failed!')
        reportNonBizData({
          reportType: 'MTG_MOF_loadFailed',
          dataCustomized: {}
        })
      }],
      title: this._options.title || i18nTools.formatByUA('_just_for_you'),
      minLength: this._options.minLength,
      offerTitleColor: this._options.offerTitleColor || '#999',
      titleColor: this._options.titleColor || '#333',
      hasOfferTitle: this._options.showOfferTitle,
    }
    if (this._options.offerData) {
      mofOpts.offerData = this._options.offerData
    } else {
      mofOpts.url = this.generateRequestUrl()
    }
    this._ui = new MoreOffer(mofOpts)

    // 绑定事件
    if (this._nImp == 1) {
      this._options.onScroll.push(this.impressionReport)
    }
    this.bindEvent()
  }

  render() {
    // 尝试渲染“参你喜欢”
    this._ui.render()
    setTimeout(() => {
      if (this._ui.checkIconStatus(0, this._options.readyLength)) {
        this._uiLoadSuccess = true
        console.log('Mof ready!')
        reportNonBizData({
          reportType: 'MTG_MOF_ready',
          dataCustomized: {}
        })
        this._options.onReady.forEach((func) => {
          func()
        })
      }
    }, (this._options.loadTimeout || 0) * 1000)

    this._widthPerOffer = window.getComputedStyle(this._ui.element.querySelector('.mtg-recommend-item'), null).width
  }

  bindEvent() {
    this._ui.onError((e) => {
      console.log('Resource load error!')
      reportNonBizData({
        reportType: 'MTG_MOF_error',
        dataCustomized: {}
      })
      this._options.onError.forEach((func) => {
        func(e)
      })
    })

    this._ui.onOfferClick((e) => {
      this._options.onOfferClick.forEach((func) => {
        func(e)
      })
      e.stopPropagation()
    })

    // 为scroll事件加入节流机制
    const scrolleThrottle = this.createThrottle((scrollX) => {
      this._options.onScroll.forEach((func) => {
        func(scrollX)
      })
    }, 1000)
    this._ui.onScroll((scrollX) => {
      scrolleThrottle(scrollX)
    })
  }

  setCampaign(newCamp) {
    this._campaign = newCamp
  }

  generateRequestUrl(baseUrl = 'https://net.rayjump.com/openapi/ad/v3') {
    const paramList = generateMofV3RequestUrl(this._App.initData, this._campaign)
    let retUrl = baseUrl
    for (const property in paramList) {
      retUrl = appendUrlParam(retUrl, property, paramList[property])
    }
    return retUrl
  }

  parseEndScreenUrl(param) {
    let ret = ''
    if (param) {
      ret = getPageUrlParams(param, this._ecUrl)
    }
    return ret
  }

  createThrottle(func, wait) {
    let throttle = (function () {
      let timeout,
        context,
        args,
        startTime = Date.parse(new Date())

      return function () {
        let curTime = Date.parse(new Date())
        let remaining = wait - (curTime - startTime)
        context = this
        args = arguments

        clearTimeout(timeout)

        if (remaining <= 0) {
          func.apply(context, args)
          startTime = Date.parse(new Date())
        } else {
          timeout = setTimeout(() => {
            func.apply(context, args)
          }, remaining)
        }
      }
    })()
    return throttle
  }

  impressionReport(positionX) {
    const left = this._lastPosition / this._widthPerOffer
    const right = positionX / this._widthPerOffer
    const reportOfferList = []

    // 考虑到用户只有在从左往右拉的时候
    if (left < right) {
      // 增量上报
      // for (let i = Math.ceil(right); i <= Math.ceil(2 * right - left); ++i) {
      //   reportOfferList.push(i)
      // }
      // 全量上报
      for (let i = 0; i <= Math.ceil(2 * right - left); ++i) {
        reportOfferList.push(i)
      }
    } else if (left > right) {
      // 增量上报
      // for (let i = Math.floor(2* left - right); i <= Math.floor(right); ++i) {
      //   reportOfferList.push(i)
      // }
      // 全量上报
      for (let i = 0; i <= Math.floor(right); ++i) {
        reportOfferList.push(i)
      }
    }

    const impressionList = []
    reportOfferList.forEach((offerN) => {
      // 上报对应offer，等待上报函数完成
      if (!this._nImpReportHistory[offerN]) {
        this._nImpReportHistory[offerN] = 1
        impressionList.push(this._ui._offerList[offerN - 1].impression_url)
      }
    })
    // Todo 上报impression失败的回滚
    reportUrlList(impressionList)
  }

  appendTo(target = document.querySelector('.container')) {
    let isAppend = false
    if(this._uiLoadSuccess) {
      reportNonBizData({
        reportType: 'MTG_MOF_show',
        dataCustomized: {}
      })
      this._ui.appendTo(target)
      isAppend = true
    }
    return isAppend
  }

  getOnlyImpression() {
    return this._ui.onlyImpression
  }

  setBackgroundColor(color = 'white') {
    this._ui.setBG(color)
  }
}